<div class="html-code-editor">
	<div class="toolbar">
		<p-button
			label="Open file…"
			icon="pi pi-folder-open"
			[text]="true"
			size="small"
			[disabled]="readOnly"
			(onClick)="openFilePicker()"
		></p-button>
		<input
			#fileInput
			type="file"
			class="file-input"
			accept=".html,.htm,text/html"
			(change)="onFileInputChange($event)"
		/>
		<span class="size">{{ value?.length || 0 }} chars · {{ kb }} KB</span>
	</div>
	<div #editorHost class="editor-host" [style.min-height]="loading ? minHeight : null">
		<div class="loading" *ngIf="loading">Loading editor…</div>
	</div>
</div>
